import { useEffect } from 'react';

/**
 * Custom-hook to enable and disable scroll-lock on main-content
 * Will enable scroll-lock on mount and disables scroll-lock on unmount
 * @returns {undefined} - no return value
 */
export const useScrollLock = () => {
  useEffect(() => {
    sessionStorage?.setItem('currentPosY', window?.scrollY);
    document?.getElementById('app-container')?.classList?.add('scroll-lock-background');

    return () => {
      window?.scrollTo(0, sessionStorage?.getItem('currentPosY') ?? 0);
      sessionStorage?.removeItem('currentPosY');
      document?.getElementById('app-container')?.classList?.remove('scroll-lock-background');
    };
  }, []);
};
